webpackJsonp([173133301296707],{

/***/ 472:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _components = __webpack_require__(3);
	
	var _marketing = __webpack_require__(8);
	
	var _blog = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Overview = function (_React$Component) {
	  _inherits(Overview, _React$Component);
	
	  function Overview(props) {
	    _classCallCheck(this, Overview);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  Overview.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'DocPage' },
	      _react2.default.createElement(_components.StripeBG, { bg2: "white", style: 'purple' }),
	      _react2.default.createElement(_marketing.Navbar, { className: 'grid-restrain' }),
	      _react2.default.createElement(
	        'section',
	        { className: 'grid-restrain grid-row full-8' },
	        _react2.default.createElement(_blog.DocToc, null),
	        _react2.default.createElement(
	          'div',
	          { className: 'content markdown-doc grid-item' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'title' },
	            'Iframes'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'SnapTest playback execution can enter and exit iframes on your page. In order to accomplish this, use the "Enter frame" and "Exit frame" actions:'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement('img', { src: 'https://res.cloudinary.com/snaptest/image/upload/v1622069591/docs/iframes/Screen_Shot_2021-05-26_at_5.52.09_PM.png' })
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Playback will move into the frame specified by the selector, and will continue until the "Exit frame" action is encountered.  If necessary, these may be nested for advanced "iframe in iframe" needs, just make sure to "exit frame" as many times as necessary.  '
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'b',
	              null,
	              'If you are having difficulties entering a frame, remember the following:'
	            )
	          ),
	          _react2.default.createElement(
	            'ul',
	            null,
	            _react2.default.createElement(
	              'li',
	              null,
	              'Increase the timeout of the "Enter Frame" action, which will continue looking for the iframe using the selector until completed.'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'If you\'re entering an iframe immediately after loading a page, we recommend setting "Require Complete Load" setting on the "Load Page" action.'
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Overview;
	}(_react2.default.Component);
	
	exports.default = Overview;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-doc-iframes-js-36ef843cfc70b4356f89.js